var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "index-call-to-action-section"
  }, [_c('call-to-action', {
    scopedSlots: _vm._u([{
      key: "info-box",
      fn: function () {
        return [_c('div', {
          staticClass: "title heading-3-regular"
        }, [_vm._v(_vm._s(_vm.fields.field_one.value.text))]), _c('div', {
          staticClass: "title heading-3-bold"
        }, [_vm._v(_vm._s(_vm.fields.field_one.value.text2))]), _c('div', {
          staticClass: "button-container"
        }, [_c('seu-button', {
          attrs: {
            "label": _vm.fields.field_one.value.buttonLabel,
            "button-link": _vm.fields.field_one.value.buttonLink,
            "button-icon-before": _vm.buttonIcon
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "image-box",
      fn: function () {
        return [_c('img', {
          directives: [{
            name: "scroll-animate",
            rawName: "v-scroll-animate"
          }, {
            name: "scroll-animate",
            rawName: "v-scroll-animate"
          }],
          attrs: {
            "src": _vm.fields.field_one.value.image,
            "alt": ""
          }
        })];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }